import { useLoginContext } from "@bindeleddet/core/contexts/login";
import { EventRegistrationStatus } from "@bindeleddet/core/types";
import { COLORS_PER_STATUS } from "./constants";
import { LABELS_PER_STATUS } from "../../../FrontPage/HeroSection/EventCard/EventStatusBadge/constants";
import { EventStatusText } from "./style";

interface Props {
  status: EventRegistrationStatus | null | undefined;
}

const EventStatus: React.FC<Props> = ({ status }) => {
  const { currentUser } = useLoginContext();
  if (!currentUser) return <EventStatusText color="#b4b6b8">Logg inn for å se arrangementsstatus</EventStatusText>;
  if (!status) return <p style={{ height: "1em" }} />;
  return <EventStatusText color={COLORS_PER_STATUS[status]}>{LABELS_PER_STATUS[status]}</EventStatusText>;
};

export default EventStatus;
